import qs from 'query-string';
import React from 'react';
import { useParams } from 'react-router-dom';

interface UseAnchorSearchProps {
  defaultParams: any;
  setSearch: any;
  needsUpdate: boolean;
  qparams: any;
}

/**
 * Anchor element (link) that needs to change Search
 */
export const useAnchorSearch = ({
  defaultParams,
  setSearch,
  needsUpdate,
  qparams,
}: UseAnchorSearchProps) => {
  const isFirstLoad = React.useRef<boolean>(true);
  const queryParams = useParams();

  // Params that are usable in Search
  const isThereValidParams = () => {
    const qparamsRaw = qs.parse(window.location.search);
    const VALID_PARAMS = Object.keys(defaultParams)
      .filter((key) => key !== 'filters')
      .filter((key) => key in qparamsRaw);
    return VALID_PARAMS.length > 0;
  };

  // This effect patches anchor elements that are not listened by "setSearch".
  React.useEffect(() => {
    let isMounted = true;

    if (isFirstLoad.current) {
      isFirstLoad.current = false;
    }

    // It's not required "needsUpdate" since that is triggered by events and NOT by the Anchor element.
    if (!isFirstLoad.current && isMounted && isThereValidParams() && !needsUpdate) {
      setSearch({ ...qparams });
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams]);
};
